module.exports = __webpack_public_path__ + "static/media/ricerca_grigio.f2aaa2ba.svg";